// @flow

import React from 'react';
import map from 'lodash/fp/map';
import ViewMoreList from '@active/awe-ui-core/lib/components/ViewMoreList';
import type { ImageItem } from 'type/type';
import ImageCard from './ImageCard/ImageCard';
import './ImageGallery.scss';

type Props = {
  total: number,
  loading: boolean,
  moreButtonText: string,
  images: Array<ImageItem>,
  onViewMore: () => void
}

const ImageGallery = ({
  total, loading, moreButtonText, images, onViewMore,
}: Props) => {
  return (
    <div className="image-gallery">
      <ViewMoreList
        length={images.length}
        total={total}
        loading={loading}
        moreButtonText={moreButtonText}
        onViewMore={onViewMore}>
        <div className="image-gallery__content">
          { map(p => (
            <ImageCard smallUrl={p.smallUrl} key={p.id || p.smallUrl} largeUrl={p.largeUrl} />
          ))(images)
          }
        </div>
      </ViewMoreList>
    </div>
  );
};

export default ImageGallery;
